import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * /register now redirects to /onboard which provides the unified
 * role-based onboarding flow (Student, Teacher, Parent, School Admin).
 */
export function RegisterPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/onboard', { replace: true })
  }, [navigate])

  return null
}